const factStyle = {
  card: {
    border: "0",
    marginBottom: "5px",
    marginTop: "5px",
    borderRadius: "6px",
    color: "rgba(0, 0, 0, 0.87)",
    background: "#fff",
    width: "100%",
    boxShadow:
      "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    fontSize: "1rem",
    lineHeight: "1.25rem",
    transition: "all 300ms linear",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
      marginBottom: "10px",
      marginTop: "10px",
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    }
  },
  cardPlain: {
    background: "transparent",
    boxShadow: "none"
  },
  cardCarousel: {
    overflow: "hidden"
  },
  fact: {
    textAlign: "left",
  },
  citation: {
    fontSize: "80%",
  }
};

export default factStyle;
